import { render, staticRenderFns } from "./CommonPrice.vue?vue&type=template&id=5187117e&"
import script from "./CommonPrice.vue?vue&type=script&lang=js&"
export * from "./CommonPrice.vue?vue&type=script&lang=js&"
import style0 from "./CommonPrice.vue?vue&type=style&index=0&media=screen&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports